import { gigQueryOptions } from "api/queries/stafferGigs";
import type { WarmableQuery } from "routing/warmQueries";
import type * as z from "zod/mini";
import type { gigSidebarSchema } from "./routing";

type QueriesInput = { search: z.infer<typeof gigSidebarSchema> };

export const gigQuery = ({ search }: QueriesInput) => ({
  ...gigQueryOptions(search.selected_gig_id),
  enabled: !!search.selected_gig_id && !search.selected_pro_id,
});

export const queries = (input: QueriesInput): Array<WarmableQuery> => [gigQuery(input)];
